<i18n src="../ecs-email-header/resources/locales.json"></i18n>
<template>
  <v-select
    filled
    dense
    class="from-field"
    background-color="surface"
    :items="fromEmails"
    :value="fromEmail"
    :disabled="!isSmtpEnabled"
    hide-details
    @change="onFromEmailUpdate"
    @click.stop
  >
    <template #prepend-inner>
      {{ $t('from') }}
    </template>
  </v-select>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EcsEmailFrom',
  props: {
    smtpDetails: {
      type: Object,
      required: true
    },
    fromEmail: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('REFERENCES', ['isSmtpEnabled']),
    fromEmails() {
      let fromEmails = [];
      if (this.smtpDetails.defaultBPFromEmailAddress !== '') {
        fromEmails.push(this.smtpDetails.defaultBPFromEmailAddress);
      }
      if (this.smtpDetails.defaultFromEmailAddress !== '') {
        fromEmails.push(this.smtpDetails.defaultFromEmailAddress);
      }
      fromEmails = fromEmails.concat(this.smtpDetails.alternateBPFromEmailAddressAliases);
      return fromEmails;
    }
  },
  watch: {
    smtpDetails(newValue, oldValue) {
      let defaultAdress = null;
      if (
        newValue.defaultBPFromEmailAddress !== '' &&
        oldValue.defaultBPFromEmailAddress !== newValue.defaultBPFromEmailAddress
      ) {
        defaultAdress = newValue.defaultBPFromEmailAddress;
      } else if (
        newValue.defaultFromEmailAddress !== '' &&
        oldValue.defaultFromEmailAddress !== newValue.defaultFromEmailAddress
      ) {
        defaultAdress = newValue.defaultFromEmailAddress;
      }

      this.onFromEmailUpdate(defaultAdress);
    }
  },
  mounted() {
    if (this.smtpDetails) {
      const defaultEmail = this.getDefaultEmail();
      this.onFromEmailUpdate(defaultEmail);
    }
  },
  methods: {
    onFromEmailUpdate(email) {
      this.$emit('updateFromEmail', email);
    },
    getDefaultEmail() {
      let defaultAdress = '';
      if (this.smtpDetails.defaultBPFromEmailAddress !== '') {
        defaultAdress = this.smtpDetails.defaultBPFromEmailAddress;
      } else if (this.smtpDetails.defaultFromEmailAddress !== '') {
        defaultAdress = this.smtpDetails.defaultFromEmailAddress;
      }
      return defaultAdress;
    }
  }
};
</script>

<style>
.from-field .v-input__prepend-inner {
  margin-top: 7px !important;
}
.from-field .v-input__append-inner {
  margin-top: 2px !important;
}
.from-field {
  height: 28px;
}
.from-field .v-input__slot,
.from-field .v-select__slot {
  min-height: 28px !important;
}
.from-field .v-text-field__details {
  margin-bottom: 0px !important;
}
</style>
